/* globals lp, jui,Class */
var _ = require('lodash');

var InlineTextStateController = require('ub/ui/inline-text/states/inline-text-state-controller').default;
var inlineTextStateSubjects = require('ub/ui/inline-text/states/inline-text-state-subjects');

module.exports = Class.create(
  lp.editor.panel.ElementPropertiesPanel,
  lp.editor.panel.ElementGeometryControls,

  /* distinct from root, block, box so we don't have interference */
  lp.editor.panel.ElementBackgroundControlsNew,

  lp.editor.panel.ElementBorderControls,
  lp.ModuleComponent,
  {
    type: 'lp-pom-text',

    installUI: function($super){
      $super();

      var self = this;

      var inlineTextPanelContainer = this.insert(document.createElement('div'));
      this.inlineTextController = InlineTextStateController(inlineTextPanelContainer);

      this.geometryPanel = this.insert(new jui.CollapsiblePanel({
        title: 'Geometry',
        attributes: {
          className: 'collapsible-panel panel-text-geometry',
        },
      }));

      this.installGeometryControls({
        insert: this.geometryPanel.insertContent.bind(this.geometryPanel),
        sizeOptions: {disableHeight: true},
      });

      this._geometryControlUIEventHandlers = _.merge(
        {},
        this._geometryControlUIEventHandlers,
        {
          changeSize: function(ev, model, um) {
            model.setWidth(ev.size.width, um);
            // The model will recalculate the height after a change in width.
            // Thus, we need to update the ui with the new calculated value
            self.element.view.e.style.height = '';
            self.controls.size.setValue(model.getSize());
          },
        }
      );

      this.borderPanel = this.insert(new jui.CollapsiblePanel({
        title: 'Border Properties',
        attributes: {
          className: 'collapsible-panel panel-text-border labels-above'
        }
      }));

      this.installBorderControls({
        insert: this.borderPanel.insertContent.bind(this.borderPanel),
        hasRadiusControl: false,
      });

      this.backgroundPanel = this.insert(new jui.CollapsiblePanel({
        title: 'Background Properties',
        attributes: {
          className: 'collapsible-panel panel-text-background',
        },
      }));

      this.installBackgroundControls({
        insert: this.backgroundPanel.insertContent.bind(this.backgroundPanel),
      });

      inlineTextStateSubjects.textEvents.subscribe(this._updatePanelVisibility.bind(this));
    },

    syncUIControls: function($super, elm) {
      $super(elm);
      this.bindGeometryControlsToElement(elm);
      this.bindBackgroundControlsToElement(elm);
      this.bindBorderControlsToElement(elm);
    },

    activate: function($super) {
      $super();
      this._updatePanelVisibility();
      this.inlineTextController.setElement(this.element);
    },

    _updatePanelVisibility: function() {
      var visible = !this.element.inEditMode;

      this.geometryPanel.setVisible(visible);
      this.borderPanel.setVisible(visible);
      this.backgroundPanel.setVisible(visible);
      this.advancedPanel.setVisible(visible);
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-text/text_element_properties_panel.js
// module id = 1090
// module chunks = 0